import enhance from './enhancer';
import Influencers from './Influencers';

export default enhance(Influencers);
